import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Settings/Simulator/ShowSimulator'

export const GENERAL_SETTINGS_REQUEST_ASYNC = createAsyncTypes('GENERAL_SETTINGS_REQUEST', typeKey)
export const UPDATE_GENERAL_SETTINGS_REQUEST = createAsyncTypes(
  'UPDATE_GENERAL_SETTINGS_REQUEST',
  typeKey
)
export const GET_TAGS_ASYNC = createAsyncTypes('GET_TAGS', typeKey)
export const GET_CANDIDATES_ASYNC = createAsyncTypes('GET_CANDIDATES', typeKey)
export const GET_RECIPIENTS_ASYNC = createAsyncTypes('GET_RECIPIENTS', typeKey)
export const ADD_RECIPIENT_ASYNC = createAsyncTypes('ADD_RECIPIENT', typeKey)
export const REMOVE_RECIPIENT_ASYNC = createAsyncTypes('REMOVE_RECIPIENT', typeKey)

export const CHANGE_SELECTION_DATA = `${typeKey}/CHANGE_SELECTION_DATA`
export const SET_TAGS = `${typeKey}/SET_TAGS`
export const SET_CANDIDATES = `${typeKey}/SET_CANDIDATES`
export const RESET_SIMULATOR = `${typeKey}/RESET_SIMULATOR`
export const SET_CANDIDATES_PAGE = `${typeKey}/SET_CANDIDATES_PAGE`
export const SET_TAGS_PAGE = `${typeKey}/SET_TAGS_PAGE`
export const SET_RECIPIENTS_PAGE = `${typeKey}/SET_RECIPIENTS_PAGE`

export const CANDIDATES_PER_PAGE = 20
export const RECIPIENTS_PER_PAGE = 20
